import { render, staticRenderFns } from "./DownloadHeroSection.vue?vue&type=template&id=47743b5c&scoped=true"
import script from "./DownloadHeroSection.vue?vue&type=script&lang=js"
export * from "./DownloadHeroSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadHeroSection.vue?vue&type=style&index=0&id=47743b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47743b5c",
  null
  
)

export default component.exports